import "flickity/dist/flickity.css"

import "./flickity"
import "./turbolinks"
